/*
 * @Author: 王月琪 qdd88899@163.com
 * @Date: 2024-10-18 15:15:30
 * @LastEditors: 王月琪 qdd88899@163.com
 * @LastEditTime: 2024-10-18 15:17:35
 * @FilePath: \yanglaodaping\yiliaodaping\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import equi from '../views/equi.vue'
import login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'equi',
    component: equi
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkNa me: "about" */ '../views/user.vue')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/order.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
